import { responsive, spacing, ThemeUICSSObject } from '@apia/theme';
import { dataGrid } from '../../tabs/entityData';
/* IMPORT HERE */

const defaultView: ThemeUICSSObject = {
  'ul.uploaderFilesList': {
    m: spacing(0),
    padding: 3,
    maxHeight: '50vh',
    overflowY: 'auto',
    listStyle: 'none',
    ...dataGrid,
    alignItems: 'stretch',
    gap: spacing(3),
    gridTemplateColumns: responsive({
      0: 'repeat(1, minmax(0, 1fr))',
      2: 'repeat(2, minmax(0, 1fr))',
      4: 'repeat(3, minmax(0, 1fr))',
    }),
    maxWidth: '100%',
  },

  '.uploader-listItem': {
    position: 'relative',

    '& > .dropzone': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    '.file__preview': (theme) => ({
      display: 'inline-flex',
      width: '100%',
      p: spacing(3),
      border: '1px solid',
      mt: spacing(3),
      ...theme.palette.getStatesFromPath('buttons.imagePreview'),
    }),
  },

  '.uploader-list__content': (theme) => ({
    p: spacing(3),
    border: '1px solid',
    overflow: 'hidden',
    ...theme.palette.getStatesFromPath('form.fields'),
    ...theme.palette.buildColorsObject({
      borderColor: 'palette.border.article',
    }),
    backgroundColor: 'palette.background.default',

    'div.uploader-list__buttons': {},

    '&.selected': {
      backgroundColor: () => theme.palette.getColor('transparent', 'selected'),
    },
  }),

  '.uploaderFilesList__withMenuElement': (theme) => {
    return {
      cursor: 'pointer',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: spacing(3),
      p: spacing(3),
      border: '1px solid #eaeaea',

      '.uploaderFilesList__withMenuElement__iconAndLabel': {
        display: 'flex',
        alignItems: 'center',
        gap: spacing(3),

        '.file-icon': {
          flexShrink: 0,
          display: responsive({ print: 'none', 0: 'inline-block' }),
        },

        '.uploaderFilesList__withMenuElement__label': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      },

      '.uploaderFilesList__withMenuElement__buttons': {
        display: responsive({ print: 'none', 0: 'flex' }),
        gap: 0,
        flexShrink: 0,
      },

      ...theme.palette.getStatesFromPath('buttons.transparentIcon'),

      '.uploaderFilesList__withMenuElement__optionsButton': {
        p: spacing(1),

        ...theme.palette.getStatesFromPath('buttons.transparentIcon'),
      },

      '&.selected, &.selected:hover': {
        backgroundColor: theme.palette.getColor('transparent', 'selected'),
      },
    };
  },

  span: {
    margin: 0,
    mt: spacing(3),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  /* PREPEND HERE */
};

export default defaultView;
